import { MailX } from "lucide-react";
import { LuSearch } from "@/Components/Icons/Icons";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export default {
  row1: [
    {
      column: "column1",
    //   columnWidth: "45%",
      rows: {
        row1: [
          {
            name: "declarationType",
            label: "Declaration Type",
            component: "dropdown",
            width:"49%",
            options: [
              {
                label: "Declaration",
                value: "Declaration",
              },
              {
                label: "Undertaking",
                value: "Undertaking",
              },
              {
                label: "Remark",
                value: "Remark",
              },
            ],
          },
          {
            name: "declarationCode",
            label: "Declaration Code",
            component: "dropdown",
            width:"49%",

            options: [
                {
                  label: "DB001-DBK Declaration - No IGST ITC availed",
                  value: "DB001",
                },
                {
                  label: "DB002-DBK Declaration - No IGST Refund claimed",
                  value: "DB002",
                },
                {
                  label: "DB003-DBK Declaration - No CENVAT credit carry forward",
                  value: "DB003",
                },
                {
                  label: "RD001 - RODTEP Declaration",
                  value: "RD001",
                },
                {
                  label: "R5001 - ROSCTL Declaration",
                  value: "R5001",
                },
              ]
              
          },
        ],
        row2: [
            {
                name: "declarationInvoice",
                label: "Invoice",
                component: "text-field",
                width:"100%",
                type: "autocomplete",
                endpoint: "getInvoiceMaster",
                params: (formData) => ({
                  exporterMasterId: formData.general?.exporterId?.id,
                }),
    
              },
              {
                name: "declarationItem",
                label: "Item",
                component: "text-field",
                width: "100%",
                type: "autocomplete",
                endpoint: "getDescription",
              },
        ],
        row3: [
            {
                name: "declarationRemarks",
                label: "Remark",
                component: "text-field",
                width: "100%",
              },
        ],
      },
    },
  ],
};
